module.exports = __webpack_public_path__ + "static/media/notification-dot.96bd13bd.svg";